import { AxiosService } from './axios.service'
import { StorageService } from './storage.service'
import { getUrlParameter } from '@helpers'

/**
 * Defines the API methods for a friend invite
 */
export class FriendInviteService {
	static baseURL = 'convite-de-amigo'

	/**
	 * List the user invited friends
	 * @return {Promise<string[]>} List friends
	 */
	static list(params) {
		return AxiosService.get(`${FriendInviteService.baseURL}/listar`, {
			params,
		}).then(({ data }) => data)
	}

	/**
	 * Get an invite link
	 * @return {Promise<string>} The invite link
	 */
	static getLink() {
		return AxiosService.get(
			`${FriendInviteService.baseURL}/buscar-hash`
		).then(
			({ data }) =>
				`${location.origin}/cadastro?convite=${data.data.friendHash}`
		)
	}

	/**
	 * Get invite hash from the query string or from the local storage
	 * @return {string} The invite hash
	 */
	static setInviteHash() {
		const hashFromUrl = getUrlParameter('convite')
		if (hashFromUrl !== undefined) StorageService.inviteHash.set(hashFromUrl)
	}

	/**
	 * Get invite hash from the local storage
	 */
	static getInviteHash() {
		const inviteHash = StorageService.inviteHash.get()
		return inviteHash
	}

	/**
	 * Remove invite hash from the local storage
	 */
	static eraseInviteHash() {
		StorageService.inviteHash.remove()
	}
}
